import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "theme-landing" }
const _hoisted_2 = {
  key: 0,
  class: "theme-landing-form__transfer-group"
}
const _hoisted_3 = { class: "theme-landing-form__stay-group" }
const _hoisted_4 = { class: "theme-landing-form__additional-group" }
const _hoisted_5 = { class: "theme-landing-form__footer" }
const _hoisted_6 = {
  key: 2,
  class: "theme-landing-filter-section"
}
const _hoisted_7 = { class: "theme-landing-filter-section__item" }
const _hoisted_8 = { class: "theme-landing-filter-section__item" }
const _hoisted_9 = { class: "theme-landing-filter-section__item" }
const _hoisted_10 = { class: "theme-landing-filter-section__item" }
const _hoisted_11 = { class: "theme-landing-filter-section__item" }
const _hoisted_12 = { class: "theme-landing-filter-section__item" }
const _hoisted_13 = { class: "theme-landing-filter-section__item" }
const _hoisted_14 = { class: "theme-landing-filter-section__item" }
const _hoisted_15 = { class: "theme-landing-filter-section__item" }

import type { SearchFormDataType } from '@interfaces/search-form';
import BoardField from '@lmt-rpb/BoardField/BoardField.vue';
import Collapse from '@lmt-rpb/Collapse/Collapse.vue';
import DirectFlight from '@lmt-rpb/DirectFlight/DirectFlight.vue';
import HotelCategory from '@lmt-rpb/HotelCategory/HotelCategory.vue';
import AdditionalCheckboxFilters from '@lmt-rpb/AdditionalCheckboxFilters/AdditionalCheckboxFilters.vue';
import MostPopularFilters from '@lmt-rpb/MostPopularFilters/MostPopularFilters.vue';
import OperatorFilter from '@lmt-rpb/OperatorFilter/OperatorFilter.vue';
import PriceSlider from '@lmt-rpb/PriceSlider/PriceSlider.vue';
import RecommendationRate from '@lmt-rpb/RecommendationRate/RecommendationRate.vue';
import RoomTypeField from '@lmt-rpb/RoomTypeField/RoomTypeField.vue';
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import SeaView from '@lmt-rpb/SeaView/SeaView.vue';
import TransferField from '@lmt-rpb/TransferField/TransferField.vue';
import SkeletonLoader from '@lmt-rpb/SkeletonLoader/SkeletonLoader.vue';
import FilterTagList from '@lmt-rpb/FilterTagList/FilterTagList.vue';
import { ref, computed } from 'vue';
import SearchBarCore from '@lmt-rpb/Organisms/SearchBarCore/SearchBarCore.vue';
import ExpandTransition from '@lmt-rpb/Atoms/ExpandTransition/ExpandTransition.vue';
import type { OperatorTypesType } from '@/components/common/types';
import { useStore } from '@/components/common/store';
import { isClientGermany } from '@/js/utils/environmentUtils';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import { useFilters } from 'src/composables/useFIlters';


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeLandingPage',
  emits: ['ThemeLandingPage:Submit'],
  setup(__props, { emit: __emit }) {

const store = useStore();

const formData = computed((): SearchFormDataType => store.state.searchMask);
const emit = __emit;
const isInitialLoad = ref(true);
const isHotelOnly = computed((): boolean => formData.value.onlyHotel);
const { isDesktop } = storeToRefs(useBreakpointStore());
const operatorTypes = computed((): OperatorTypesType[] => store.state.types.operator);
const { filtersCount } = useFilters();

const activeFilterHeadline = computed((): string => (filtersCount.value ? `(${filtersCount.value} aktiv)` : ''));
const showSuns = isClientGermany();
const currencyType = computed(() => store.getters.getCurrencyType);

const maxTravelDurationError = computed(() => store.state.searchMask.maxTravelDurationError);

const tourOperatorLoading = computed((): boolean => store.state.tourOperatorLoading);

const isOpenAdditionalCheckboxFilters = (): boolean => {
	if (!isInitialLoad.value) {
		return true;
	}

	if (
		formData.value.additionalCheckboxFilters?.ratingAttributes?.length ||
		formData.value.additionalCheckboxFilters?.hotelAttributes?.length
	) {
		isInitialLoad.value = false;
		return true;
	}

	return false;
};

const openAdditionalCheckboxFilters = computed((): boolean => isOpenAdditionalCheckboxFilters());
const onSubmit = (): void => {
	emit('ThemeLandingPage:Submit');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isDesktop))
      ? (_openBlock(), _createBlock(SearchBarCore, {
          key: 0,
          class: "theme-landing-form",
          onSearchSubmit: onSubmit
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" mobile searchmask "),
    (!_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "theme-landing-form",
          autocomplete: "off",
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createVNode(Collapse, {
            label: "Suche",
            class: "theme-landing-form__collapse",
            block: true,
            open: true
          }, {
            default: _withCtx(() => [
              _createVNode(SearchBarCore, {
                variant: 'inline',
                class: "theme-landing-form__search-bar--mobile",
                "show-submit-button": false
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" mobile filters "),
          _createVNode(Collapse, {
            label: 'Filter ' + activeFilterHeadline.value,
            class: "theme-landing-form__collapse",
            block: true,
            open: true
          }, {
            default: _withCtx(() => [
              _createVNode(FilterTagList, {
                class: "theme-landing-form__filter-tag-list",
                "show-reset-in-header": true
              }),
              _createVNode(ExpandTransition, null, {
                default: _withCtx(() => [
                  (!isHotelOnly.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "theme-landing-form__subheader--hotellist" }, "Flug und Transport", -1 /* HOISTED */)),
                        _createVNode(DirectFlight, { class: "theme-landing-form__direct-flight-field" }),
                        _createVNode(TransferField, { class: "theme-landing-form__transfer-field" })
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "theme-landing-form__subheader--hotellist" }, "Verpflegung und Zimmer", -1 /* HOISTED */)),
                _createVNode(BoardField, { class: "theme-landing-form__board-types-field" }),
                _createVNode(RoomTypeField, { class: "theme-landing-form__room-type-field" }),
                _createVNode(SeaView, { class: "theme-landing-form__sea-view-field" })
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "theme-landing-form__subheader--hotellist hotel-list-filters__header--before-input hotel-list-filters__header--hotel-category" }, " Hotelkategorie ab ", -1 /* HOISTED */)),
              _createVNode(HotelCategory, {
                value: formData.value.hotelCategory,
                "show-suns": _unref(showSuns),
                class: "theme-landing-form__hotel-category-filter"
              }, null, 8 /* PROPS */, ["value", "show-suns"]),
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "theme-landing-form__subheader--hotellist hotel-list-filters__header--before-input" }, "Weiterempfehlungsrate ab", -1 /* HOISTED */)),
              _createVNode(RecommendationRate, {
                value: formData.value.minMeanRecommendationRate,
                class: "theme-landing-form__recommendation-filter"
              }, null, 8 /* PROPS */, ["value"]),
              _createVNode(PriceSlider, {
                "default-value": formData.value.maxPrice,
                currency: currencyType.value,
                class: "theme-landing-form__price-filter"
              }, null, 8 /* PROPS */, ["default-value", "currency"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Collapse, {
                  "collapse-headline": "Beliebteste Filter",
                  class: "theme-landing-form__collapse hotel-list-filters__collapse hotel-list-filters__most-popular",
                  open: true
                }, {
                  header: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("h2", { class: "theme-landing-form__subheader--hotellist hotel-list-filters__header--before-input" }, " Beliebteste Filter ", -1 /* HOISTED */)
                  ])),
                  default: _withCtx(() => [
                    _createVNode(MostPopularFilters, {
                      filters: formData.value.mostPopularFilters
                    }, null, 8 /* PROPS */, ["filters"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(Collapse, {
                  class: "theme-landing-form__collapse hotel-list-filters__collapse",
                  open: openAdditionalCheckboxFilters.value
                }, {
                  header: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("h2", { class: "theme-landing-form__subheader--hotellist hotel-list-filters__header--before-input" }, "Mehr Filter", -1 /* HOISTED */)
                  ])),
                  default: _withCtx(() => [
                    _createVNode(AdditionalCheckboxFilters, {
                      filters: formData.value.additionalCheckboxFilters
                    }, null, 8 /* PROPS */, ["filters"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["open"]),
                (!tourOperatorLoading.value)
                  ? (_openBlock(), _createBlock(OperatorFilter, {
                      key: 0,
                      class: "theme-landing-form__operator-filter",
                      disabled: !operatorTypes.value || operatorTypes.value.length == 0
                    }, null, 8 /* PROPS */, ["disabled"]))
                  : (_openBlock(), _createBlock(SkeletonLoader, {
                      key: 1,
                      class: "hotel-list-filters__skeleton",
                      "loader-width": 100,
                      "loader-height": 7,
                      "border-radius": '1rem',
                      "width-unit": '%'
                    }))
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(RoundedButton, {
              type: "submit",
              theme: "extra",
              class: "theme-landing-form__submit-button",
              disabled: maxTravelDurationError.value,
              onKeydown: [
                _withKeys(_withModifiers(onSubmit, ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(onSubmit, ["prevent"]), ["space"])
              ]
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "theme-landing-form__submit-button-text" }, " Suchen ", -1 /* HOISTED */)
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "onKeydown"])
          ])
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode("Desktop View Filters "),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createVNode(FilterTagList, {
            "show-reset-in-header": false,
            class: "theme-landing-filter-section__filter-list"
          }),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "theme-landing-filter-section__line" }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", {
              class: _normalizeClass(["theme-landing-filter-section__subheader", isHotelOnly.value ? 'theme-landing-filter-section__subheader--disabled' : ''])
            }, " Transfer und Flug ", 2 /* CLASS */),
            _createVNode(TransferField, {
              disabled: isHotelOnly.value,
              class: "theme-landing-filter-section__dropdown"
            }, null, 8 /* PROPS */, ["disabled"]),
            _createVNode(DirectFlight, { disabled: isHotelOnly.value }, null, 8 /* PROPS */, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Zimmer", -1 /* HOISTED */)),
            _createVNode(RoomTypeField, { class: "theme-landing-filter-section__dropdown" })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Verpflegung", -1 /* HOISTED */)),
            _createVNode(BoardField, { class: "theme-landing-filter-section__dropdown" }),
            _createVNode(SeaView)
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "theme-landing-filter-section__line" }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Weiterempfehlungsrate ab", -1 /* HOISTED */)),
            _createVNode(RecommendationRate, {
              value: formData.value.minMeanRecommendationRate
            }, null, 8 /* PROPS */, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Hotelkategorie ab", -1 /* HOISTED */)),
            _createVNode(HotelCategory, {
              value: formData.value.hotelCategory,
              "show-suns": _unref(showSuns)
            }, null, 8 /* PROPS */, ["value", "show-suns"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(PriceSlider, {
              "default-value": formData.value.maxPrice,
              currency: currencyType.value
            }, null, 8 /* PROPS */, ["default-value", "currency"])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "theme-landing-filter-section__line" }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_13, [
            _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Beliebteste Filter", -1 /* HOISTED */)),
            _createVNode(MostPopularFilters, {
              class: "theme-landing-filter-section__checkbox-group",
              filters: formData.value.mostPopularFilters
            }, null, 8 /* PROPS */, ["filters"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Mehr Filter", -1 /* HOISTED */)),
            _createVNode(AdditionalCheckboxFilters, {
              class: "theme-landing-filter-section__checkbox-group",
              filters: formData.value.additionalCheckboxFilters
            }, null, 8 /* PROPS */, ["filters"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "theme-landing-filter-section__subheader" }, "Reiseveranstalter", -1 /* HOISTED */)),
            (!tourOperatorLoading.value)
              ? (_openBlock(), _createBlock(OperatorFilter, {
                  key: 0,
                  class: "theme-landing-form__operator-filter",
                  disabled: !operatorTypes.value || operatorTypes.value.length == 0
                }, null, 8 /* PROPS */, ["disabled"]))
              : (_openBlock(), _createBlock(SkeletonLoader, {
                  key: 1,
                  class: "hotel-list-filters__skeleton",
                  "loader-width": 100,
                  "loader-height": 7,
                  "border-radius": '1rem',
                  "width-unit": '%'
                }))
          ]),
          _createVNode(RoundedButton, {
            type: "submit",
            theme: "extra",
            class: "theme-landing-filter-section__submit-button",
            disabled: maxTravelDurationError.value,
            onKeydown: [
              _withKeys(_withModifiers(onSubmit, ["prevent"]), ["enter"]),
              _withKeys(_withModifiers(onSubmit, ["prevent"]), ["space"])
            ],
            onClick: _withModifiers(onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("span", { class: "theme-landing-form__submit-button-text" }, "Suchen", -1 /* HOISTED */)
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onKeydown"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})